import React from "react";

export interface UIRadioProps {
  value?: boolean;
  valueChanged?: (value: boolean) => void;
  label?: string;
  attrs?: React.InputHTMLAttributes<HTMLInputElement>;
  readOnly?: boolean;
  name: string;
}

export default UIRadio;

function UIRadio(props: UIRadioProps) {
  const attrs: React.InputHTMLAttributes<HTMLInputElement> = { ...props.attrs };

  if (props.readOnly !== true) {
    attrs.onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
      if (props.valueChanged != null) {
        props.valueChanged(event.target.defaultChecked);
      }

      if (props.attrs?.onChange != null) {
        props.attrs.onChange(event);
      }
    };
  }

  return (
      <input type="radio" name={props.name} defaultChecked={props.value === true} {...attrs} readOnly={props.readOnly === true}  className="ip-ch"/>
  );
}
